<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h2 class="card-header-title">User Profile</h2>
      </div>
      <div class="card-content">
        <div class="columns flex-row">
          <div class="column is-6">
            <b-field label="Name">
              <b-input v-model="full_name" readonly></b-input>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field label="Email">
              <b-input v-model="user_email" readonly></b-input>
            </b-field>
          </div>
        </div>
        <div class="columns flex-row">
          <div class="column is-6">
            <b-field label="Username">
              <b-input v-model="user_name" readonly></b-input>
            </b-field>
          </div>
          <div v-if="user_port" class="column is-6">
            <b-field label="Port">
              <b-input v-model="user_port" readonly></b-input>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <h2 class="card-header-title">Change Password</h2>
      </div>
      <div class="card-content">
        <form>
          <validation-observer
            ref="changePasswordObserver"
            tag="div"
            v-slot="{invalid, valid, untouched, errors}"
          >
            <div class="columns flex-column">
              <div class="column is-6">
                <input-with-validation
                  :name="'old_password'"
                  :errorLabel="'old password'"
                  :rules="'required|min:6'"
                  :label="'Old Password'"
                  v-model="old_password"
                  :type="'password'"
                  :password-reveal="true"
                ></input-with-validation>
              </div>
              <div class="flex-row">
                <div class="column is-6">
                  <input-with-validation
                    :name="'password'"
                    :errorLabel="'password'"
                    :rules="'required|min:6'"
                    :label="'Password'"
                    v-model="password"
                    :type="'password'"
                    :vid="'password'"
                    :password-reveal="true"
                  ></input-with-validation>
                </div>

                <div class="column is-6">
                  <input-with-validation
                    :name="'password_confirmation'"
                    :errorLabel="'password'"
                    :rules="'required|confirmed:password|min:6'"
                    :label="'Confirm Password'"
                    v-model="password_confirmation"
                    :type="'password'"
                    :password-reveal="true"
                  ></input-with-validation>
                </div>
              </div>

              <div class="column is-12">
                <button
                  class="button is-medium is-primary"
                  :class="{ 'is-loading': loading }"
                  @click.prevent="changePassword"
                >Change Password</button>
              </div>
            </div>
          </validation-observer>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import InputWithValidation from "@/modules/commonModule/components/formInputs/inputWithValidation";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import ChangePasswordMutation from "@/modules/commonModule/api/graphql/mutations/ChangePassword.gql";
export default {
  name: "ChangePassword",

  components: { InputWithValidation, ValidationObserver, ValidationProvider },

  data() {
    return {
      full_name: "",
      user_name: "",
      user_email: "",
      user_port: null,
      old_password: "",
      password: "",
      password_confirmation: "",
      loading: false
    };
  },
  mounted() {
    this.full_name = this.getUserDetails().full_name;
    this.user_name = this.getUserDetails().user_name;
    this.user_email = this.getUserDetails().user_email;
    if (this.getUserDetails().user_port) {
      this.user_port = this.getUserDetails().user_port.name;
    }
  },

  methods: {
    getUserDetails() {
      return this.$store.getters.getUserDetails;
    },
    updateData: function({ key, value }) {
      this[key] = value;
    },

    resetValues: async function() {
      this.password = "";
      this.old_password = "";
      this.password_confirmation = "";

      requestAnimationFrame(() => {
        this.$refs.changePasswordObserver.reset();
      });
    },

    changePassword: async function() {
      const isValid = await this.$refs.changePasswordObserver.validate();
      if (!isValid) {
        return;
      }

      this.loading = true;

      this.$apollo
        .mutate({
          fetchPolicy: "no-cache",
          mutation: ChangePasswordMutation,
          variables: {
            data: {
              old_password: this.old_password,
              password: this.password,
              password_confirmation: this.password_confirmation
            }
          }
        })
        .then(response => {
          this.resetValues();

          this.$toast.open({
            duration: 3000,
            position: "is-top-right",
            message: "Your password has been successfully changed.",
            type: "is-success"
          });
        })
        .catch(error => {
          console.log(error);
          this.$toast.open({
            duration: 4000,
            position: "is-top-right",
            message: "An error occured while trying to change your password",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
